import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },

  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    },
    {
      path: 'centers',
      name: 'centers',
      component: () => import('@/views/center/index'),
      meta: { title: '个人中心', icon: 'leixing-icon' },
      hidden: true
    },]
  }
]

export const asyncRouterMap = [

  {
    path: '/feed',
    component: Layout,
    redirect: '/feed/FeederManagement',
    name: 'feed',
    meta: { title: '猪场管理', icon: 'siwei-data' },
    children: [
      {
        path: 'FeederManagement',
        name: 'FeederManagement',
        component: () => import('@/views/feed/FeederManagement/index'),
        meta: { title: '饲喂器管理', icon: 'siweileixing-icon' }
      },
      {
        path: 'analysis',
        name: 'analysis',
        component: () => import('@/views/feed/analysis/index'),
        meta: { title: '数据分析', icon: 'siweibiaozhun' }
      },
      {
        path: 'details',
        name: 'details',
        component: () => import('@/views/feed/analysis/Details/index'),
        meta: { title: '数据详情', icon: 'siweibiaozhun' },
        hidden: true
      },
      {
        path: 'feedDevice',
        name: 'feedDevice',
        component: () => import('@/views/feed/feedDevice/index'),
        meta: { title: '猪只管理', icon: 'zhuzhiguanli-icon' }
      },
      {
        path: 'FeedDifferent',
        name: 'FeedDifferent',
        component: () => import('@/views/feed/FeedDifferent/index'),
        meta: { title: '饲喂时段', icon: 'leixing-icon' }
      },
      {
        path: 'stand-feed',
        name: 'stand-feed',
        // component: () => import('@/views/feed/standard/index'), /* 最早页面逻辑 */
        component: () => import('@/views/feed/stand-feed/index'),
        meta: { title: '饲喂标准', icon: 'siweibiaozhun' },
      },
      {
        path: 'standard',
        name: 'standard-feed',
        component: () => import('@/views/feed/standard/index'),
        meta: { title: '饲喂标准新增', icon: 'siweibiaozhun' },
        hidden: true
      },
      {
        path: 'childbirth',
        name: 'childbirth',
        component: () => import('@/views/feed/childbirth/index'),
        meta: { title: '分娩数据', icon: 'childbirth' },
        hidden: true
      },
      {
        path: 'peihuai',
        name: 'peihuai',
        component: () => import('@/views/feed/peihuai/index'),
        meta: { title: '配怀数据', icon: 'childbirth' },
        hidden: true
      },
      {
        path: 'conservation',
        name: 'conservation',
        component: () => import('@/views/feed/conservation/index'),
        meta: { title: '保育数据', icon: 'childbirth' },
        hidden: true
      },
      {
        path: 'platform',
        name: 'platform',
        component: () => import('@/views/pigInternet/platform'),
        meta: { title: '历史饲喂数据', icon: 'leixing-icon' }
      },
    ]
  },
  {
    path: '/pigfarm',
    component: Layout,
    redirect: '/pigfarm/farm',
    name: 'pigfarm',
    meta: { title: '猪场设置', icon: 'leixing-icon' },
    children: [
      {
        path: 'farm',
        name: 'farm',
        component: () => import('@/views/pigfarm/farm'),
        meta: { title: '猪场', icon: 'zhuzhiguanli-icon' }
      },
      {
        path: 'ls',
        name: 'ls',
        component: () => import('@/views/pigfarm/ls'),
        meta: { title: '栏舍', icon: 'leixing-icon' }
      },
      {
        path: 'unit',
        name: 'unit',
        component: () => import('@/views/pigfarm/unit'),
        meta: { title: '单元', icon: 'leixing-icon' }
      },
      {
        path: 'area',
        name: 'area',
        component: () => import('@/views/pigfarm/area'),
        meta: { title: '区域', icon: 'zhuzhiguanli-icon' }
      },
      {
        path: 'Gateway',
        name: 'Gateway',
        component: () => import('@/views/pigfarm/Gateway'),
        meta: { title: '网关', icon: 'zhuzhiguanli-icon' }
      },
    ]
  },
  {
    path: '/management',
    component: Layout,
    redirect: '/management/log',
    name: 'management',
    meta: { title: '日志管理', icon: 'leixing-icon' },
    children: [
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/logManagement/Feedlog'),
        meta: { title: '饲喂实时数据', icon: 'leixing-icon' }
      },
      {
        path: 'logs',
        name: 'logs',
        component: () => import('@/views/logManagement/Feedlogs'),
        meta: { title: '饲喂日志', icon: 'leixing-icon' }
      },
      {
        path: 'abnormal',
        name: 'abnormal',
        component: () => import('@/views/logManagement/abnormal'),
        meta: { title: '饲喂异常日志', icon: 'leixing-icon' }
      },
      {
        path: 'System',
        name: 'System',
        component: () => import('@/views/logManagement/System'),
        meta: { title: '系统操作日志', icon: 'leixing-icon' }
      },
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限管理', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      },
    ]
  },

  { path: '*', redirect: '/404', hidden: true },

]

export default new Router({
  mode: 'history', //后端支持可开
  base: '/feed',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js